import React from 'react';
import CompFmtSelectbox from './comp-fmt-selectbox.js';
import { formAtt } from '@assets/js/util/commonUtil.js';

const SearchForm = ({ formObj, onValChange, onGridSearch, params = {} }) => {
    const fields = Object.keys(formObj.params);
    const colClass = fields.length <= 3 ? 'col-sm-4' : 'col-sm-3';

    const onKeyup = (e) => {
        if (e.keyCode === 13) {
            onGridSearch();
        }
    }
    
    return (
        <div className="search-form-container mb-1" id={formObj.id}>
            <div className="row">
                <div className="col-12">
                    <form className="needs-validation" noValidate="">
                        <div className="row g-3">
                        {fields.map((key) => {
                            const field = formObj.params[key];

                            // If field type is selectbox, render CompFmtSelectbox
                            if (field.type === 'selectbox') {
                                const attrs = formAtt({
                                    id: field.id,
                                    label: field.label,
                                    value: params[field.id] || '',
                                    classCol: field.colClass ? field.colClass : colClass
                                });

                                return (
                                    <React.Fragment key={key}>
                                        {field.newLine && <div className="w-100"></div>}

                                        <CompFmtSelectbox
                                            attrs={attrs}
                                            grpCd={field.grpCd}
                                            selectType={field.selectType || "A"}
                                            onChange={onValChange}
                                        />
                                    </React.Fragment>
                                );

                            } else {

                                // id에 'date'가 포함되어 있으면 datepicker 타입으로 변경
                                const inputType = field.id && field.id.toLowerCase().includes('date') ? 'date' : 'text';

                                // Default: render input field
                                return (
                                    <React.Fragment key={key}>
                                        {field.newLine && <div className="w-100"></div>}

                                        <div className={colClass} style={{ marginBottom: '0px'}}>
                                            <label htmlFor={field.id} className="form-label">
                                                {field.label}
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type={inputType}
                                                    className="form-control"
                                                    style={{paddingRight: '0.2rem'}}
                                                    id={field.id}
                                                    value={params[field.id] || ''}
                                                    maxLength={field.maxLength}
                                                    onChange={onValChange}
                                                    onKeyUp={onKeyup}
                                                    disabled={field.disabled}
                                                />
                                                {params[field.id] && !field.disabled && (
                                                    <button
                                                        className="btn btn-outline-secondary"
                                                        type="button"
                                                        onClick={() => {
                                                            if (onValChange) {
                                                                const fakeEvent = {
                                                                    target: {
                                                                        id: field.id,
                                                                        value: ''
                                                                    }
                                                                };
                                                                onValChange(fakeEvent);
                                                            }
                                                        }}
                                                        title="지우기"
                                                        style={{
                                                            padding: '0.375rem 0.75rem',
                                                            paddingLeft: '0rem',
                                                            borderLeft: 'none',
                                                            backgroundColor: '#ffffff',
                                                            color: '#6c757d',
                                                            borderColor: '#ced4da'
                                                        }}
                                                    >
                                                        <i className="bi bi-x-lg"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            }
                        })}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SearchForm;